import Vue from 'vue';
import VueFirestore  from 'vue-firestore';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';

Vue.use(VueFirestore, {
  key: 'fid'
});

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBVRRIv8tGLjpevqbN8pj0zHmAPoNZ85rc",
  authDomain: "playposit-dasher.firebaseapp.com",
  databaseURL: "https://playposit-dasher.firebaseio.com",
  projectId: "playposit-dasher",
  storageBucket: "playposit-dasher.appspot.com",
  messagingSenderId: "672103940015",
  appId: "1:672103940015:web:e5064bbf3160d959"
});

export const firestore = firebaseApp.firestore();
export const database = firebaseApp.database();
